<div class="flex-column h-100">
  <app-portal-header style="position: sticky; top: 0"
                     [displayRightMenu]="false"
                     [displayRightLogo]="true"
                     [displayCalendarIcon]="false">
  </app-portal-header>
  <div class="main-wrap h-auto">
    <h4>{{ articleNews.mainHeadline }}</h4>
    <a *ngIf="articleNews.linkToSourceArticle" [href]="articleNews.linkToSourceArticle" target="_blank" class="main-text-font text-sm">View
      Source
      Article</a>
    <p class="muted text-sm">{{ articleNews.releaseDate }}<span *ngIf="articleNews.source">({{ articleNews.source }}
      )</span>
    </p>
    <p class="content-news">{{ articleNews.headline }}</p>
    <p class="content-news">{{ articleNews.byLine }}</p>
    <p class="content-news">{{ articleNews.content }}</p>
    <p class="content-news">{{ articleNews.tickers }}</p>
  </div>
  <app-main-footer></app-main-footer>
</div>
